import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type AnalyticsFillProps = IconComponentBaseProps;

export const AnalyticsFill = ({
  className,
  width = 20,
  height = 20,
  fill = defaultTheme.mantineColors.gray[7],
}: AnalyticsFillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_4163_306595"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4163_306595)">
        <path
          d="M6.76249 9.99999C6.58541 9.99999 6.437 10.0599 6.31728 10.1796C6.1977 10.2994 6.13791 10.4479 6.13791 10.625V13.3333C6.13791 13.5104 6.19784 13.6588 6.3177 13.7785C6.43742 13.8984 6.58589 13.9583 6.76312 13.9583C6.9402 13.9583 7.0886 13.8984 7.20832 13.7785C7.32791 13.6588 7.3877 13.5104 7.3877 13.3333V10.625C7.3877 10.4479 7.32784 10.2994 7.20812 10.1796C7.08825 10.0599 6.93971 9.99999 6.76249 9.99999ZM13.2369 5.83332C13.0598 5.83332 12.9114 5.89318 12.7917 6.01291C12.6721 6.13277 12.6123 6.28124 12.6123 6.45832V13.3333C12.6123 13.5104 12.6721 13.6588 12.7919 13.7785C12.9117 13.8984 13.0603 13.9583 13.2375 13.9583C13.4146 13.9583 13.563 13.8984 13.6827 13.7785C13.8023 13.6588 13.8621 13.5104 13.8621 13.3333V6.45832C13.8621 6.28124 13.8021 6.13277 13.6823 6.01291C13.5626 5.89318 13.4141 5.83332 13.2369 5.83332ZM9.99978 11.6667C9.82256 11.6667 9.67416 11.7265 9.55457 11.8462C9.43485 11.9661 9.37499 12.1146 9.37499 12.2917V13.3333C9.37499 13.5104 9.43492 13.6588 9.55478 13.7785C9.67464 13.8984 9.82312 13.9583 10.0002 13.9583C10.1774 13.9583 10.3258 13.8984 10.4454 13.7785C10.5651 13.6588 10.625 13.5104 10.625 13.3333V12.2917C10.625 12.1146 10.5651 11.9661 10.4452 11.8462C10.3253 11.7265 10.1769 11.6667 9.99978 11.6667ZM4.42312 17.0833C4.00214 17.0833 3.64582 16.9375 3.35416 16.6458C3.06249 16.3542 2.91666 15.9978 2.91666 15.5769V4.42312C2.91666 4.00214 3.06249 3.64582 3.35416 3.35416C3.64582 3.06249 4.00214 2.91666 4.42312 2.91666H15.5769C15.9978 2.91666 16.3542 3.06249 16.6458 3.35416C16.9375 3.64582 17.0833 4.00214 17.0833 4.42312V15.5769C17.0833 15.9978 16.9375 16.3542 16.6458 16.6458C16.3542 16.9375 15.9978 17.0833 15.5769 17.0833H4.42312ZM10.0002 9.79166C10.1774 9.79166 10.3258 9.73173 10.4454 9.61187C10.5651 9.492 10.625 9.34353 10.625 9.16645C10.625 8.98923 10.5651 8.84082 10.4452 8.72124C10.3253 8.60152 10.1769 8.54166 9.99978 8.54166C9.82256 8.54166 9.67416 8.60159 9.55457 8.72145C9.43485 8.84131 9.37499 8.98978 9.37499 9.16687C9.37499 9.34409 9.43492 9.49249 9.55478 9.61207C9.67464 9.7318 9.82312 9.79166 10.0002 9.79166Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
